import axios from "axios";

const state = {
	apiURL: "https://api.knowatt.com"
};

// Getter functions
const getters = {};

// Mutations
const mutations = {};

// Actions
const actions = {
	async getSites({ commit, state }, userId) {
		const { data } = await axios.get(state.apiURL + "/admin/getSites.php", {
			params: {
				userId: userId
			}
		});
		return data;
	},
	async getSiteStatus({ commit, state }) {
		const { data } = await axios.get(state.apiURL + "/admin/getSiteStatus.php");
		return data;
	},
	async getChannelStatus({ commit, state }, siteId) {
		const { data } = await axios.get(state.apiURL + "/admin/getChannelStatus.php", {
			params: {
				siteId: siteId
			}
		});
		return data;
	},
	async getLinkedUsers({ commit, state }, siteId) {
		const { data } = await axios.get(state.apiURL + "/admin/getLinkedUsers.php", {
			params: {
				siteId: siteId
			}
		});
		return data;
	},
	async getAdminUsers({commit, state}) {
		const { data } = await axios.get(state.apiURL + "/admin/getAdminUsers.php");
		return data;
	},
	async updateLinkedUsers({ commit, state }, linkData) {
		const { data } = await axios.get(state.apiURL + "/admin/updateLinkedUsers.php", {
			params: {
				admin_id: linkData['admin_id'],
				sites: linkData['sites']
			}
		});
		return data;
	},
	async getCompareSites({ commit, state }, userId) {
		const { data } = await axios.get(state.apiURL + "/admin/getCompareSites.php", {
			params: {
				userId: userId
			}
		});
		return data;
	},
	async getSiteTypes({ commit, state }) {
		const { data } = await axios.get(state.apiURL + "/admin/getSiteTypes.php");
		return data;
	},
	async getSuppliers({ commit, state }, siteId) {
		const { data } = await axios.get(state.apiURL + "/admin/getSuppliers.php", {
			params: {
				site: siteId
			}
		});
		return data;
	},
	async getChannels({ commit, state, rootState }, user) {
		const { data } = await axios.get(state.apiURL + "/admin/getChannels.php", {
			params: {
				site: user.siteId,
				user: user.email
			}
		});
		return data;
	},
	async getChannel({ commit, state, rootState }, channelId) {
		const { data } = await axios.get(state.apiURL + "/admin/getChannel.php", {
			params: {
				channelId: channelId
			}
		});
		return data;
	},
	async getAppliences({ commit, state, rootState }, device) {
		const { data } = await axios.get(state.apiURL + "/admin/getAppliences.php", {
			params: {
				device: device
			}
		});
		return data;
	},
	async getDeviceTypes({ commit, state }) {
		const { data } = await axios.get(state.apiURL + "/admin/getDeviceTypes.php");
		return data;
	},
	async updateDevice({ commit, state }, channel) {
		const { data } = await axios.post(state.apiURL + "/admin/updateChannel.php", channel);
		return data;
	},
	async updateGateway({ commit, state }, gateway) {
		const { data } = await axios.post(state.apiURL + "/admin/updateGateway.php", gateway);
		return data;
	},
	async addGateway({ commit, state }, gateway) {
		const { data } = await axios.post(state.apiURL + "/admin/createGateway.php", gateway);
		return data;
	},
	async createChannel({ commit, state }, channel) {
		const { data } = await axios.post(state.apiURL + "/admin/createChannel.php", channel);
		return data;
	},
	async addApplience({ commit, state }, applience) {
		const { data } = await axios.post(state.apiURL + "/admin/addApplience.php", applience);
		return data;
	},
	async removeGateway({ commit, state }, gateway) {
		const { data } = await axios.post(state.apiURL + "/admin/deleteGateway.php", gateway);
		return data;
	},
	async removeChannel({ commit, state }, channel) {
		const { data } = await axios.post(state.apiURL + "/admin/deleteChannel.php", channel);
		return data;
	},
	async getChannelTypes({ commit, state, rootState }) {
		const { data } = await axios.get(state.apiURL + "/admin/getChannelTypes.php", {
			params: {
				id: rootState.auth.user.siteId
			}
		});
		return data;
	},
	async deleteRate({ commit, state, rootState }, id) {
		const { data } = await axios.get(state.apiURL + "/admin/deleteRates.php", {
			params: {
				id: id
			}
		});
		return data;
	},
	async getRates({ commit, state, rootState }, site) {
		const { data } = await axios.get(state.apiURL + "/admin/getRates.php", {
			params: {
				site: site
			}
		});
		return data;
	},
	async addRates({ commit, state, rootState }, rate) {
		let requestBody = {
			site: !!rootState.auth.defaultSiteId ? rootState.auth.defaultSiteId : rootState.auth.user.siteId,
			rates: rate
		}
		const { data } = await axios.post(state.apiURL + "/admin/createRates.php", requestBody);
		return data;
	},
	async addGroupCircuits({ commit, state, rootState }, groupData) {
		const { data } = await axios.post(state.apiURL + "/admin/createGroupCircuit.php", groupData);
		return data;
	},
	async deleteGroupCircuits({ commit, state, rootState }, id) {
		const { data } = await axios.get(state.apiURL + "/admin/deleteGroupCircuits.php", {
			params: {
				id: id
			}
		});
		return data;
	},
	async getGroupCircuits({commit, state, rootState}, siteId) {
		const { data } = await axios.get(state.apiURL + "/admin/getGroupCircuits.php", {
			params: {
				id: siteId
			}
		});
		return data;
	},
	async getChannelAllTypes({ commit, state, rootState }) {
		const { data } = await axios.get(state.apiURL + "/admin/getChannelAllTypes.php");
		return data;
	},
	async addChannelType({ commit, state }, channelType) {
		const { data } = await axios.post(state.apiURL + "/admin/createChannelType.php", channelType);
		return data;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
